import React from "react";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { useHookstate } from "@hookstate/core";

import { mostraCnpjFormatado } from "@refere/ui-utils/ui/utils/format";

import globalState from "../../features/global-state";

import LogoMag from "../../resources/images/logo-mag.png"

const SummaryBox = () => {
  const simulacao = useHookstate(globalState.simulacao)
  const loja = useHookstate(globalState.faseLoja)

  return (
    simulacao.get() && loja?.logo &&
      <Paper
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          m: "16px 15px",
          p: "16px"
        }}
      >
          <Box
            display="flex"
            flexDirection="column"
          >
              <Typography>Nome: {simulacao.proponente?.nome.get()}</Typography>
              <Typography>CNPJ: {mostraCnpjFormatado(simulacao.proponente?.cnpj?.get())}</Typography>
              <Typography>Cotação: {simulacao.idSimulacao.get()}</Typography>
          </Box>
          <img alt="logo" id="imgLogoCliente" src={LogoMag} style={{ width: "100px" }} />
      </Paper>
  );
}

export default SummaryBox